<template>
  <section id="customer">
    <div class="c-top-container">
      <div class="ct-header-container">
        <div class="grid-row gap-16">
          <div class="page-label">
            Members
          </div>
          <CustomerDashboard />
        </div>
        <div class="grid-column gap-16">
          <SACSearch
            darkMode
            :width="200"
            :height="40"
            :search="customerTableSearch"
            placeholder="Search"
            @input="(value) => changeSearch(value.trim())"
          />
          <button
            type="button"
            class="export-btn"
            @click="exportData"
          >
            Export
          </button>
          <SelectedPartner />
        </div>
      </div>
    </div>
    <div class="c-body-container">
      <div class="c-content-container">
        <CustomerTable />
      </div>
    </div>
    <ActionModal />
  </section>
</template>

<script>
import CustomerDashboard from '@shared/components/customer/CustomerDashboard.vue';
import CustomerTable from '@shared/components/customer/CustomerTable.vue';
import ActionModal from '@shared/components/customer/ActionModal.vue';
import SelectedPartner from '@shared/components/admin/SelectedPartner.vue';

import adminMixin from '@shared/mixins/adminMixin';
import customerMixin from '@shared/mixins/customerMixin';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import _ from 'lodash';
import exportToFile from '@shared/lib/util/exportToFile';
import SACSearch from '@shared/components/sac/SACSearch.vue';
import SACTableSearch from '@shared/components/table/SACTableSearch.vue';
import PlanFilter from '@shared/components/customer/PlanFilter.vue';

export default {
  name: 'CustomerView',
  metaInfo: {
    title: 'SmartAC.com | Members',
  },
  components: {
    PlanFilter,
    SACTableSearch,
    SACSearch,
    SelectedPartner,
    CustomerDashboard,
    CustomerTable,
    ActionModal,
  },
  mixins: [adminMixin, customerMixin, customerDetailMixin],
  watch: {
    selectedCorpId() {
      this.$store.dispatch('getPartnerProviderPlans');
      this.initialLoad();
    },
  },
  async mounted() {
    if (this.isManufactureAdmin) {
      this.$router.replace('/quality');
    } else {
      this.$store.dispatch('getPartnerProviderPlans');
      this.initialLoad();
    }
  },
  created() {
    this.debouncedFetchCustomers = _.debounce(() => {
      this.$store.dispatch('getAllCustomers');
    }, 500);
  },
  methods: {
    changeSearch(value) {
      this.$store.dispatch('changeCustomerValue', {
        field: 'customerTableSearch',
        value,
      });
      this.$store.dispatch('changeTableOption', {
        field: 'page',
        value: 1,
      });
      this.debouncedFetchCustomers();
    },
    async exportData() {
      const thatData = await this.$store.dispatch('exportCustomerData');
      const payload = {
        data: thatData,
        filename: 'members.csv',
      };
      exportToFile(payload);
    },
    initialLoad() {
      this.$store.dispatch('getAllCustomers');
      this.$store.dispatch('getCustomersCount');
    },
  },
};
</script>

<style lang="scss" scoped>
section#customer {
  @include section-container;

  .c-top-container {
    @include section-top-container;

    .ct-header-container {
      @include section-header-container;
      align-items: flex-start;

      .ct-header {
        @include section-header;
      }
      .export-btn {
        height: 38px;
        padding: 0 8px;
        color: $N50;
        display: flex;
        align-items: center;
        white-space: nowrap;
        font-size: 0.875rem;
        font-weight: 700;
        border: 1px solid $N50;
        border-radius: 8px;
        line-height: 1;
      }
    }
    .ct-content-container {
      @include section-top-content-container;
    }
  }

  .c-body-container {
    @include section-body-container;

    .c-content-container {
      @include section-content-container;
    }
  }
}
</style>
